export const USER_CHECK = "/auth/user-check/";
export const LOGIN = "/auth/login/";
export const FIRST_LOGIN = "/auth/verify-exam-app?user_name=";
export const MOCK_REGISTRATION = "/mock/registration";